module.exports = __webpack_public_path__ + "static/img/Sam-Kerr.546baa3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sam-Kerr.jpg
// module id = CJEW
// module chunks = 0